import classes from "../subPagesClasses.module.scss";
import { CustomerInsightOutletContext } from "../..";
import { useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import { getInputListSubTestAdequation } from "components/pages/Subscriptions/physicalPerson/SubscriptionQuestions/SubTestAdequation";
import MessageBox from "components/elements/MessageBox";
import I18n from "components/materials/I18n";
import { ETestAdequationGroups } from "common/enums/Scpi/PhysicalPerson/Groups/ETestAdequationGroups";

export default function CustomerInsightTestAdequation() {
	const { subscription, renderInputList } = useOutletContext<CustomerInsightOutletContext>();

	const [inputList, setInputList] = useState<Record<ETestAdequationGroups, JSX.Element | null> | null>(null);

	useEffect(() => {
		if (!subscription) return;
		setInputList(getInputListSubTestAdequation(subscription, true, true));
	}, [subscription]);

	if (!inputList || !subscription) return null;
	return (
		<div className={classes["root"]}>
			{!subscription.testAdequation && (
				<MessageBox className={classes["warning-prelevement"]} type="info" text={I18n.asset.pages.client.sub_pages.customer_insight.no_data} />
			)}
			{subscription.testAdequation && renderInputList(inputList)}
		</div>
	);
}
